import { Grid2, Typography, Button } from "@mui/material";
import { Link, useNavigate, useParams } from "react-router-dom";
import TaskCard from "../../../components/TaskCard";
import Breadcrumbs from "../../../components/Breadcrumbs";
import { useStudents } from "../../../context/students";
import Students1 from "../../../assets/images/images/students3.jpg";
import Students2 from "../../../assets/images/images/students4.jpg";
import { useTranslate } from "../../../hooks/useTranslate";
import Preloader from "../../../components/Preloader";
import LockedPage from "../../../components/LockedPage";
import useStatuses from "../../../context/status/useStatuses";

const MentorPathway = () => {
    const { studentId } = useParams();
    const { t } = useTranslate();
    const navigate = useNavigate();
    const { activeStudent, activeStudentId } = useStudents();
    const { showMentorPathway } = useStatuses();

    return (
        <div className="page-content">
            <div className="student-head-section" />
            <Grid2
                container
                spacing={2}
                className={showMentorPathway ? "min-head-section-height--small" : "min-head-section-height"}
            >
                <Grid2 size={{ xs: 12, md: 7, lg: 8 }}>
                    <Breadcrumbs
                        breadcrumbs={[
                            { label: t("navigation.home"), href: `/home/${activeStudentId}` },
                            { label: t("mentorPathway.title"), current: true },
                        ]}
                    />
                    <Typography variant="h1" className="text-white">
                        {t("mentorPathway.title")}
                    </Typography>
                    <Typography variant="body1" className="mt-4 text-white" component="div">
                        {t("mentorPathway.subtitle")}
                    </Typography>
                    <Typography variant="h1" component="h2" className="mt-8 text-white">
                        {t("common.quickLinks")}
                    </Typography>

                </Grid2>
                <Grid2 size={{ xs: 9, md: 5, lg: 4 }}>
                    <div className="images-head-section">
                        <div className="img-head-section">
                            <img alt="students-1" src={Students1} />
                        </div>
                        <div className="img-head-section">
                            <img alt="students-2" src={Students2} />
                        </div>
                    </div>
                </Grid2>
            </Grid2>
            <Preloader isLoading={!activeStudent}>
                <LockedPage showPermissionText isLocked={!showMentorPathway}>
                    <Grid2 container spacing={4} className="mt-4">
                        {activeStudent?.mentorPathwayStartDate && activeStudent?.mentorPathwayFinishDate && new Date(activeStudent?.mentorPathwayStartDate) < new Date() && (
                            <Grid2 size={{ xs: 12, sm: 6, lg: 4 }}>
                                <TaskCard title={t("mentorPathway.studentProfileForm")}>
                                    <Typography variant="body1" component="div">
                                        {t("mentorPathway.studentProfileFormText")}
                                    </Typography>
                                    <Button
                                        onClick={() => navigate(`/mentor-pathway/student-profile-form/${activeStudentId}`)}
                                        className="w-full mt-4 text-base button-primary"
                                    >
                                        {t("button.viewNow")}
                                    </Button>
                                </TaskCard>
                            </Grid2>
                        )}
                        <Grid2 size={{ xs: 12, sm: 6, lg: 4 }}>
                            <TaskCard title={t("mentorPathway.sessionNotes")}>
                                <Typography variant="body1" component="div">
                                    {t("mentorPathway.sessionNotesText")}
                                </Typography>
                                <Button
                                    onClick={() => navigate(`/mentor-pathway/session-notes/${activeStudentId}`)}
                                    className="w-full mt-4 text-base button-primary"
                                >
                                    {t("button.viewNow")}
                                </Button>
                            </TaskCard>
                        </Grid2>
                    </Grid2>
                </LockedPage>
            </Preloader>
        </div>
    );
};

export default MentorPathway;
